import { Product } from './product.model';

export class Company{
    name : string
    products : Product[]
}